import { Tag, type TagProps } from '../Tag';
import { tagButtonRecipe } from './styles.css';

export interface TagButtonProps extends TagProps {
  id?: string;
  onClick: () => void;
}

export function TagButton(props: TagButtonProps) {
  return <Tag component="button" className={tagButtonRecipe()} {...props} />;
}
